import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { assetKeys } from "@/domains/assets/api/keys";
import type { Asset, AssetStatus } from "@/domains/assets/api/types";
import { updateAssetStatus } from "@/domains/assets/mocks/assetsService";

type UpdateStatusVars = {
  id: string;
  status: AssetStatus;
};

export function useUpdateAssetStatus(): UseMutationResult<Asset, Error, UpdateStatusVars> {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: UpdateStatusVars) => updateAssetStatus(id, status),
    onSuccess: (asset) => {
      client.invalidateQueries({ queryKey: assetKeys.lists() });
      client.invalidateQueries({ queryKey: assetKeys.detail(asset.id) });
    },
  });
}
